import clsx from 'clsx';
import React, {FC} from 'react';

interface ProseProps {
  className?: string;
}

/**
 * 文档排版容器：套住语义化长正文（h2/h3/p/ul/table/img…）即得全套排版，
 * 样式集中在 src/styles/v3/prose.css（base.css 的作用域 reset 已清零元素默认样式，
 * 由该文件在 .v3-prose 作用域内重建）。正文组件不逐个写工具类。
 * 宽表请外包 <div className="v3-table-wrap">；提示块用 className="v3-note"。
 */
const Prose: FC<ProseProps> = ({children, className}) => (
  <div className={clsx('v3-prose max-w-3xl mx-auto', className)}>{children}</div>
);

export default Prose;
